import styled from "styled-components";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CancelIcon from "../../assets/createEnvAssets/CancelIcon";
import {useContext} from "react";
import ModalContext from "../demoPointEnv/envResultsTable/ModalContext";
import LoadingIcon from "../../assets/threatGuardAssets/LoadingIcon";

export const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    textAlign: 'center',
    borderRadius: 2,
};


const CancelButtonWrapper = styled.div`
  display: flex;
  justify-content: end;

  .cancel_button {
    width: 10px;
    cursor: pointer;
  }
`;

const MessageContent = styled.div`
  font-size: 15px;
  margin: 5px 0px;
`;

const MessageWrapper = styled.div`
  padding: 10px;
  .title {
    font-size: 22px;
    color: #EC407A;
  }
`;

const Button = styled.button`

  width: 70px;
  background: var(--color-brand-pink-primary);
  color: white;
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  display: inline;

  &:hover {
    background: #fa105b;
  }
`;


export default function PopupMessage() {
    const {threatGuardModalIsOpen, setThreatGuardModalIsOpen, contentMessage} = useContext(ModalContext);
    const [firstMessage, secondMessage,thirdMessage] = contentMessage;
    const handleClose = () => setThreatGuardModalIsOpen(false);
    return (
        <div>
            <Modal
                open={threatGuardModalIsOpen}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} id={"threatGuard-modal"}>
                    <CancelButtonWrapper>
                                <span className={"cancel_button"} onClick={() => setThreatGuardModalIsOpen(false)}>
                                    <CancelIcon/>
                                </span>
                    </CancelButtonWrapper>
                    <MessageWrapper id={"message-wrapper"}>
                        <LoadingIcon/>
                        <p id={"first-message"} className={"title"}> {firstMessage}</p>
                        <MessageContent id={"second-message"}>{secondMessage}</MessageContent>
                        <MessageContent id={"third-message"}>{thirdMessage}</MessageContent>
                    </MessageWrapper>
                    <Button onClick={() => setThreatGuardModalIsOpen(false)}>Close</Button>
                </Box>
            </Modal>
        </div>
    );
};
